import axios from "axios";

export const toHttps = (url) => {
  if (!url) return url;
  return url.startsWith("http://") ? url.replace(/^http:\/\//i, "https://") : url;
};

export const fetchImageWithAuth = async (imageUrl) => {
  try {
    const httpsUrl = toHttps(imageUrl);
    const response = await axios.get(httpsUrl, {
      headers: {
        Authorization: "QuindlTokPATFileUpload2025#$$TerOiu$",
      },
      responseType: "arraybuffer",
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching image over HTTPS:", error);
    if (imageUrl && imageUrl.startsWith("http://")) {
      console.warn(
        "Image source uses HTTP and was blocked by the browser. Serve images over HTTPS or proxy them through your backend."
      );
    }
    return null;
  }
};
